<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Link Group" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Link Group #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <LinkGroupForm :id="id" @hidePreloader="hidePreloader"></LinkGroupForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import LinkGroupForm from './forms/LinkGroupForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'LinkGroup',
        props: ['id'],
        components: {
            Preloader, LinkGroupForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            }
        }
    }
</script>

<style scoped>

</style>
